<div *ngIf="ancillariesLoading$ | async" class="grow flex flex--column">
  <fin-loader
    class="font-body-1 grow flex flex--center"
    [type]="LoaderType.EMBEDDED"
    [title]="'ancillaries.seats.reassigningYourSeats'"
  ></fin-loader>
</div>

<main>
  <ng-container *ngIf="(ancillariesLoading$ | async) !== true">
    <ng-container *ngIf="(orderStatus$ | async) !== OrderStatus.PENDING; else loader">
      <ng-container data-testid="flow-step-seats">
        <fcom-notification
          *ngIf="showNoSeatsToReassignLeftNotification$ | async"
          [theme]="NotificationTheme.WARNING"
          [layout]="NotificationLayout.BLOCK"
          [iconName]="SvgLibraryIcon.ALERT_TRIANGLE"
          class="block"
          [class.mr-xxsmall-b]="true"
        >
          {{ 'MMB.checkIn.exitRowSeats.notifications.passengerDeclidedExitRowSeat' | finLocalization }}
        </fcom-notification>
        <fin-check-in-seatmap
          [order$]="order$"
          [bound$]="bound$"
          [passengers$]="passengers$"
          [ancillaryLoader$]="ancillaryLoader$"
          (confirmStep)="goToNextStep()"
          (seatsUpdate)="onSeatsUpdate($event)"
          (checkInAssignSeat)="checkInAssignSeatForFlight($event)"
          (switchAncillaryLoaderOff)="ancillariesLoading$.next(false)"
        ></fin-check-in-seatmap>
      </ng-container>
    </ng-container>
  </ng-container>
</main>

<ng-template #loader>
  <div class="align-center fill">
    <fin-loader aria-live="polite" [type]="LoaderType.EMBEDDED" [waitingFor]="'MMB.checkIn.loadingOrder'"></fin-loader>
  </div>
</ng-template>

<ng-template #loadingModal>
  <div *ngIf="updateServicesModalOn$ | async">
    <link rel="dns-prefetch" [href]="checkoutUrl | finSafe: 'resource'" />

    <fcom-modal
      [fitToContent]="true"
      [forceRemainOpen]="true"
      [open]="true"
      [title]="'MMB.checkIn.review.titles.updatingServices' | finLocalization"
      [buttons]="null"
    >
      <fin-loader
        aria-live="polite"
        [hideTitle]="true"
        [type]="LoaderType.EMBEDDED"
        [waitingFor]="'MMB.checkIn.review.waitingForReview'"
      ></fin-loader>
    </fcom-modal>
  </div>
</ng-template>

<ng-container *ngTemplateOutlet="loadingModal"></ng-container>
